import { render, staticRenderFns } from "./datatable4.vue?vue&type=template&id=03b064dd"
import script from "./datatable4.vue?vue&type=script&lang=js"
export * from "./datatable4.vue?vue&type=script&lang=js"
import style0 from "./datatable4.vue?vue&type=style&index=0&id=03b064dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports